import { css } from '@emotion/react';

import { mediaquery } from 'shared/styles/styleFunctions';
import { fontSizes } from 'shared/styles/text';
import theme from 'shared/styles/themes';

export default css({
  '&.submission-modules': {
    margin: '0 1rem 20vh 1rem',
    [mediaquery.md]: {
      margin: '0 1rem',
    },
  },
  '.download-files-button': {
    marginRight: 'auto',
  },
  '.download-files-button__btn': {
    paddingLeft: 0,
  },
  '.submission-modules': {
    '&__control-wrapper': {
      justifyContent: 'space-between',
      alignItems: 'center',
    },
    '&__control-wrapper--no-selection': {
      justifyContent: 'end',
    },
    '&__select-actions': {
      alignItems: 'center',
      '& > button': {
        marginRight: theme.space[3],
      },
    },
    '&__name-review-wrapper': {
      alignItems: 'center',
      justifyContent: 'space-between',
    },
    '&__header': {
      alignItems: 'center',
      flexGrow: 1,
      justifyContent: 'space-between',
      paddingLeft: theme.space[3],
      margin: `${theme.space[4]} 0`,
    },
    '&__status-select > div': {
      marginTop: 0,
    },
    '&__creator-name': {
      fontWeight: 700,
      fontSize: fontSizes[5],
      paddingLeft: theme.space[5],
    },
    '&__creator-info': {
      marginLeft: theme.space[4],
    },
  },
  '.divider': {
    height: '100%',
    [mediaquery.md]: {
      height: '60px',
    },
  },
  '.profile-picture__placeholder--xs': {
    height: '2.5rem',
    width: '2.5rem',
  },
  '.profile-picture__img--xs': {
    height: '2.5rem',
    width: '2.5rem',
  },
});
